var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"header",attrs:{"row":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"shrink":""}},[_c('h2',[_vm._v(_vm._s(_vm.header))])]),_vm._t("actions")],2)}
var staticRenderFns = []

export { render, staticRenderFns }